// * We limit the number of filters people can select in a section to
// *   a. limit bots / crawlers from selecting too many
// *   b. avoid qs from hitting its 20 array parsing limit (see: https://github.com/ljharb/qs?tab=readme-ov-file#parsing-arrays)
export const DYNAMIC_FILTER_SECTION_LIMIT = 10;
